import React from 'react';
import './Images.scss';

const Images = ({ img1, img2 }) => (
    <div className="images-list">
        {img1 && <img src={img1} />}
        {img2 && <img src={img2} />}
    </div>
);

export default Images;



// WEBPACK FOOTER //
// ./src/components/ui/Images/Images.js